import { useState, useEffect } from 'react';
import { useLandbotContext } from 'context/landbot.context';

export default function useLandbotVisibility() {
  const { landbot } = useLandbotContext();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    landbot.events.on('set_visible', setVisible);
    return () => landbot.events.off('set_visible', setVisible);
  }, [landbot]);

  return visible;
}